import React, { useState }  from 'react'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
const sample = 'The core part of an operating system'
export default function LlmContext() {
    const [loadingMsg, setLoadingMsg]= useState(false)
    const [wordResult, setWordResult]= useState(sample)
    const [userInput, setUserInput] = useState({'word':'What is Kernel'})
    const onChange2Input = ({ currentTarget: x }) => { setUserInput({ ...userInput, [x.name]: x.value }) }
    const onClick2Define=async()=>{
        setLoadingMsg(true)
        setWordResult('')
        try {
            const { data: res } = await axios.post(`${APIURL}/llm/context`,userInput)
            setWordResult(res['definition'])
            setLoadingMsg(false)
        } catch (err) {
            console.log(err)
        }
    }
      return (
        <div className='p-1'>
        <div className='text-left'>
        <p className='text-[8px] mb-[4px]'>
        <b>My word list:</b><br/>
        <ul>
        <li>Kernel - The core part of an operating system responsible for managing hardware, memory, and processes.</li>
        <li>AI - Artificial Intelligence is a broad term used to describe engineered systems that have been taught to do a task that typically requires human intelligence.</li>
        <li>Data Lake - A storage repository where data is stored in its raw format. Data lakes allow for more flexibility than a more rigid data warehouse.</li>
        </ul>
        </p>
        <div className='mt-[2px] flex'>
        <input className='pl-[2px] border border-gray-800 w-full md:w-80 mr-[2px]'  name='word' type='text' defaultValue='What is Kernel' onChange={onChange2Input}/>
        <button className='bg-gray-800 hover:bg-gray-700 h-auto pl-[8px] pr-[8px] text-white text-[12px]' onClick={onClick2Define}>Check definition</button>
        </div>

 
        {loadingMsg?<p className='flex text-xs'>Please wait for 5seconds<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:''}
        </div>
       <div className='text-left'>
        {wordResult}
       </div>
       </div>
      )
}